export default "__VITE_ASSET__17ac64c5__"